const crewReadyStandalone =
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true;

const crewReadyUrl = new URL(window.location.href);
const crewReadyPreviewTheme = crewReadyUrl.searchParams.has('preview_theme_id');
const crewReadyDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

// A home-screen shortcut should never stay attached to a Shopify theme-preview URL.
// If an old shortcut opens a preview while running standalone, immediately send it
// to the same page on the real CrewReady storefront and strip preview-only params.
if (crewReadyStandalone && crewReadyPreviewTheme) {
  ['preview_theme_id', 'preview_key', 'pb', '_fd', '_sc', '_ab'].forEach((key) => {
    crewReadyUrl.searchParams.delete(key);
  });

  const destination = new URL(
    `${crewReadyUrl.pathname}${crewReadyUrl.search}${crewReadyUrl.hash}`,
    'https://crewreadysupply.com'
  );

  window.location.replace(destination.toString());
}

class CrewReadyAppInstall {
  constructor(element) {
    this.element = element;
    this.installButton = element.querySelector('[data-install-button]');
    this.dismissButton = element.querySelector('[data-install-dismiss]');
    this.instructions = element.querySelector('[data-install-instructions]');
    this.promptEvent = null;
    this.isStandalone = crewReadyStandalone;
    this.isPreview = crewReadyPreviewTheme || crewReadyDesignMode;
    this.isMobile = window.matchMedia('(max-width: 749px)').matches;
    this.isIOS = /iPhone|iPad|iPod/i.test(window.navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    this.dismissedUntil = Number(localStorage.getItem('crewready-install-dismissed-until') || 0);
    this.isInstalled = localStorage.getItem('crewready-installed') === 'true';
    this.bind();
  }

  bind() {
    if (this.isStandalone || this.isPreview || this.isInstalled || !this.isMobile || Date.now() < this.dismissedUntil) return;

    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      this.promptEvent = event;
      this.show();
    });

    window.addEventListener('appinstalled', () => {
      localStorage.setItem('crewready-installed', 'true');
      this.hide();
    });

    this.installButton.addEventListener('click', () => this.install());
    this.dismissButton.addEventListener('click', () => {
      this.snooze();
      this.hide();
    });

    window.setTimeout(() => this.show(), 6500);
  }

  snooze(days = 14) {
    const until = Date.now() + days * 24 * 60 * 60 * 1000;
    localStorage.setItem('crewready-install-dismissed-until', String(until));
  }

  show() {
    if (!this.isStandalone && !this.isPreview && !this.isInstalled && this.isMobile && Date.now() >= this.dismissedUntil) {
      this.element.hidden = false;
    }
  }

  hide() {
    this.element.hidden = true;
  }

  async install() {
    if (this.promptEvent) {
      const promptEvent = this.promptEvent;
      this.promptEvent = null;
      await promptEvent.prompt();
      const choice = await promptEvent.userChoice;

      if (choice.outcome === 'accepted') {
        localStorage.setItem('crewready-installed', 'true');
      } else {
        this.snooze();
      }

      this.hide();
      return;
    }

    this.instructions.textContent = this.isIOS
      ? 'Tap Share, then choose Add to Home Screen.'
      : 'Open your browser menu and choose Install app or Add to Home screen.';
    this.instructions.hidden = false;
    this.installButton.hidden = true;
    this.snooze();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const element = document.querySelector('[data-app-install]');
  if (element) new CrewReadyAppInstall(element);
});
